export default __webpack_public_path__ + "static/media/TrustWallet.b32ca4d2.svg";